/**
 * Clerk appearance config that maps to the app's CSS custom properties.
 * Automatically adapts to all themes (neutral, warm, kiwi) and dark mode.
 */
import { dark } from "@clerk/themes";

/** Minimal type for Clerk appearance; matches the shape used by ClerkProvider. */
interface ClerkAppearance {
  baseTheme?: typeof dark;
  variables?: Record<string, string>;
  elements?: Record<string, Record<string, unknown>>;
}

const sharedVariables: ClerkAppearance["variables"] = {
  colorPrimary: "var(--primary)",
  colorBackground: "var(--card)",
  colorText: "var(--foreground)",
  colorTextSecondary: "var(--muted-foreground)",
  colorInputBackground: "var(--background)",
  colorInputText: "var(--foreground)",
  colorNeutral: "var(--foreground)",
  colorDanger: "var(--destructive)",
  borderRadius: "var(--radius)",
  fontFamily:
    '"Azeret Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSize: "0.8125rem",
};

const sharedElements: ClerkAppearance["elements"] = {
  footerAction: { display: "none" },
  cardBox: {
    boxShadow: "var(--shadow-lg)",
    border: "1px solid var(--border)",
  },
  headerTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
  },
};

export function getClerkAppearance(isDark: boolean): ClerkAppearance {
  return {
    baseTheme: isDark ? dark : undefined,
    variables: {
      ...sharedVariables,
      colorBackground: isDark ? "var(--popover)" : "var(--card)",
    },
    elements: sharedElements,
  };
}
